import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Row, Col, Text } from 'shared/components'

import * as styles from './styles'

const DeleteButtonComponent = ({ value: event, onRejectMemberInvoice }) => (
  <Grid>
    <Row center="xs">
      <Col xs={12}>
        <Button
          circle
          small
          outlined
          disabled={event.currentState !== 'DRAFT'}
          onClick={onRejectMemberInvoice}
        >
          <FontAwesomeIcon size="lg" icon="trash" css={styles.icon} />
          <Text size={11}>Reject</Text>
        </Button>
      </Col>
    </Row>
  </Grid>
)

DeleteButtonComponent.propTypes = {
  value: PropTypes.shape(),
  onRejectMemberInvoice: PropTypes.func.isRequired,
}

export default DeleteButtonComponent
